import script from "./ChatDetailHeaderActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDetailHeaderActions.vue?vue&type=script&setup=true&lang=js"

import "./ChatDetailHeaderActions.vue?vue&type=style&index=0&id=53b8fadb&lang=scss"

const __exports__ = script;

export default __exports__